module.exports = [{"type":"title","text":"2024-03-14"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續調整接口：下單接口支持保證止盈止損功能。"},{"type":"html","text":"現貨新增:倒計時全部撤單 功能"},{"type":"html","text":"永續新增:倒計時全部撤單 功能"},{"type":"html","text":"現貨新增:服務器時間接口"},{"type":"html","text":"現貨新增:有效方式，目前支持PostOnly、GTC、IOC,不填寫則默認GTC"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-03-14.json
// module id = Jip9
// module chunks = 3